import { render, staticRenderFns } from "./VatRate.vue?vue&type=template&id=718772a3&scoped=true"
import script from "./VatRate.vue?vue&type=script&lang=js"
export * from "./VatRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718772a3",
  null
  
)

export default component.exports